/**
 * 参训报表
 * @description 参训报表
 * @author wuTao
 * @date 2020-10-13
 */
import React from 'react';
import ReactDOM from 'react-dom'
import { connect } from 'dva';

import { component_tool, framework_tool, utils_tool} from '@/tool';
let { checkStrLength,Session } = utils_tool;
import '@/styles/containers/dataReport/trainReport/index.less'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

let { WizCard, WizTable, WizTabs, WizSpin, WizRow, WizCol, WizIcon, WizButton,WizHtmlTableToExce } = component_tool;
let { WizContainer,modelUtils } = framework_tool;
import moment from "moment";

const formatterDate = (time1,time2) => {
  if (time1 && time2) return moment(time1).format('YYYY年MM月DD日 HH:mm')+" - "+moment(time2).format('HH:mm')
  if (time1) return moment(time1).format('YYYY年MM月DD日 HH:mm')
  if (time2) return moment(time2).format('YYYY年MM月DD日 HH:mm')
  return '';
}

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/live/liveList/liveStatisticsList/liveTrainReport') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('liveStatisticsInfo', record)
      } else {
        record = Session.get('liveStatisticsInfo') || 0
      }
    } else if (history.location.pathname === '/trainingStatistics/trainingStatisticsList/dataReport') {
        if (history.location && history.location.record) {
          record = history.location.record;
          Session.set('trainingStatisticsDataReport', record)
        } else {
          record = Session.get('trainingStatisticsDataReport') || 0
        }
    }
  }

  return record
}
class TrainReport extends WizContainer {

  componentName = 'TrainReport';

  constructor(props) {
    super(props);
    this.state = {
      apiParams: {},
    }
    this.initialValue = getParamRecord(props.history);
    this.positionTrainReportList=[];
    this.dealerTrainReportList = [];
    this.positionRuleList = [];
    this.scopeName = '';
    this.groupPositionName = '';
    this.liveEntityInfo = {};
  }

  _componentWillMount() {
    let initialValue = this.initialValue;
    log.info('initialValue',initialValue);
    if (initialValue && initialValue.id!=null && initialValue.version!=null){
      this.getLiveDealerTrainReportList(initialValue.id,initialValue.version);
      this.getLivePositionTrainReportList(initialValue.id,initialValue.version);
      this.getPositionRuleList(initialValue.id);
      if (initialValue.type===null || initialValue.type===1){
        this.getLiveEntityInfo(initialValue.entityId);
      }else if (initialValue.type===2 && initialValue.bizType===1 && initialValue.entityList && initialValue.entityList instanceof Array && initialValue.entityList.length===1){
        let liveEntityInfo = {};
        initialValue.entityList.forEach(value => {
          const {entityId,entityName,entityStartTime,entityEndTime,entityType} = value;
          liveEntityInfo = {id:entityId,name:entityName,startDate:entityStartTime,endDate:entityEndTime};
          initialValue.entityType = entityType;
        });
        this.initialValue = initialValue;
        this.liveEntityInfo = liveEntityInfo;
      }else if (initialValue.type===2 && initialValue.bizType===2 && initialValue.entityList && initialValue.entityList instanceof Array && initialValue.entityList.length>0){
        let liveEntityInfo = {};
        let nameStr = "";
        initialValue.entityList.forEach(value => {
          const {entityId,entityName,entityStartTime,entityEndTime,entityType} = value;
          liveEntityInfo = {id:entityId,name:entityName,startDate:entityStartTime,endDate:entityEndTime};
          if (nameStr===''){
            nameStr = entityName;
          }else {
            nameStr = nameStr + '、'+entityName
          }
          liveEntityInfo = {name:nameStr,startDate:entityStartTime,endDate:entityEndTime};
          initialValue.entityType = entityType;
        });
        this.initialValue = initialValue;
        this.liveEntityInfo = liveEntityInfo;
      }
    }
  }

  // componentDidMount() {
  //   let tabKey = this.state.tabKey;
  //   //利用reactdom.finddomnode()来获取真实DOM节点
  //   const tableCon = ReactDOM.findDOMNode(this.refs['train_report_excel_'+tabKey]);
  //   const table = tableCon.querySelector('table');
  //   //为table设置id属性
  //   table.setAttribute('id', 'table-to-xls'+tabKey)
  // }

  getLiveEntityInfo(id){
    this.doAction({
      path: 'interactLive/getInfo',
      payload: {
        key: "liveEntityInfo",
        apiParams: {
          id: id
        }
      }
    });
  }
  /** 获取岗位组考核规则 */
  getPositionRuleList(statisticsRuleId) {
    this.doAction({
      path: 'positionRule/list',
      payload: {
        key: 'positionRules',
        apiParams: {statisticsRuleId : statisticsRuleId}
      },
    })
  }

  /**获取对应的岗位组报表数据 */
  getLivePositionTrainReportList(statisticsRuleId,version) {
    this.doAction({
      path: 'positionTrainReport/getPositionTrainReportList',
      payload: {
        key: 'getPositionTrainReportList',
        apiParams: {
          statisticsRuleId: statisticsRuleId,
          version: version,
        }
      }
    });
  }
  /**获取对应的经销商数据 */
  getLiveDealerTrainReportList(statisticsRuleId,version) {
    this.doAction({
      path: 'dealerTrainReport/getDealerTrainReportList',
      payload: {
        key: 'getDealerTrainReportList',
        apiParams: {
          statisticsRuleId: statisticsRuleId,
          version: version,
        }
      }
    });
  }

  propsAndStateOnChange = {
    getDealerTrainReportList:this._getDealerTrainReportListOver.bind(this),
    getPositionTrainReportList:this._getPositionTrainReportListOver.bind(this),
    positionRules:this._getPositionRulesListOver.bind(this),
    liveEntityInfo:this._getLiveEntityInfoOver.bind(this)
  }

  _getLiveEntityInfoOver(nextProps, nextState) {
    if (nextProps.liveEntityInfo.code == 1) {
      this.liveEntityInfo = nextProps.liveEntityInfo.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }

  _getPositionRulesListOver(nextProps, nextState) {
    if (nextProps.positionRules.code == 1) {
      let positionRuleList = nextProps.positionRules.data;
      this.positionRuleList = positionRuleList;
      let scopeName = '';
      let scope = null;
      let groupPositionName = '';
      if (positionRuleList && positionRuleList instanceof Array && positionRuleList.length>0){
        positionRuleList.forEach(value => {
          const {position,name,orgName} = value;
          if (position && name){
            if (groupPositionName===''){
              groupPositionName = name + '('+position + ')';
            }else {
              groupPositionName = groupPositionName + '、'+name + '('+position + ')';
            }
          }
          scope = value.scope;
        })
        if (scope != null ){
          if (scope===1){
            scopeName = '销售';
          }else if (scope===2){
            scopeName = '售后';
          }else if (scope===3){
            scopeName = '销售售后';
          }
          this.scopeName = scopeName;
          this.groupPositionName = groupPositionName;
        }
      }
    }
    return true;
  }

  _getDealerTrainReportListOver(nextProps, nextState) {
    if (nextProps.getDealerTrainReportList.code == 1) {
      let dealerTrainReportList = nextProps.getDealerTrainReportList.data;
      this.dealerTrainReportList = dealerTrainReportList;
    }
    return true;
  }
  _getPositionTrainReportListOver(nextProps, nextState) {
    if (nextProps.getPositionTrainReportList.code == 1) {
      let positionTrainReportList = nextProps.getPositionTrainReportList.data;
      this.positionTrainReportList = positionTrainReportList;
    }
    return true;
  }
  /**改变tab状态判定是否需要重新调用接口 */
  _onChange = (key) => {
    if (this.state.tabKey !== key) {
      this.setState({
        tabKey: key,
        apiParams: {},
        time: new Date().getTime()
      });
    }
  }

  /**简单结构行 */
  _tableRowSimple(title, value) {
    return (
      <tr>
        <WizRow className="report-row">
          <WizCol className="report-left-col" span={3}> <td className="report-td-min"> {title}: </td></WizCol>
          <WizCol className="report-right-col" span={21}> <td> {value} </td></WizCol>
        </WizRow>
      </tr>
    )
  }

  /**简单结构行 */
  _tableRow(title, value) {
    return (
      <tr>
        <td class="table-title table-td-title" style={{ width: 200 }}> {title}：</td>
        <td class="table-value" colspan="11"> {value} </td>
      </tr>
    )
  }

  /**经销商参训统计行 */
  _dealerRow({name, dealerTotal, trainCount, trainRate, userTotal, userLoginCount, userLoginRate, dealerTarget, targetRate, userValidCount, userValidRate}) {
    return (
      <>
        <tr>
          <td class="table-title table-td-title" rowspan="2"> {name}数：</td>
          <td class="table-title table-td-content" rowspan="2"> {dealerTotal}</td>
          <td class="table-title table-td-title">参训经销商数：</td>
          <td class="table-title table-td-content">{trainCount}</td>
          <td class="table-title table-td-title">经销商参训率：</td>
          <td class="table-title table-td-content">{trainRate+'%'}</td>
          <td rowspan="2" class="table-title table-td-title">{name}应参训人数：</td>
          <td class="table-title table-td-content" rowspan="2">{userTotal}</td>
          <td class="table-title table-td-title">登录人数：</td>
          <td class="table-title table-td-content">{userLoginCount}</td>
          <td class="table-title table-td-title">登录率：</td>
          <td class="table-title table-td-content">{userLoginRate+'%'}</td>
        </tr>
        <tr>
          <td class="table-title">达标经销商数：</td>
          <td class="table-title">{dealerTarget}</td>
          <td class="table-title">达标率：</td>
          <td class="table-title">{targetRate+'%'}</td>
          <td class="table-title">有效参训人数：</td>
          <td class="table-title">{userValidCount}</td>
          <td class="table-title">有效参训率：</td>
          <td class="table-title">{userValidRate+'%'}</td>
        </tr>
      </>
    )
  }

  /**头部提示具体内容 */
  _headerInfo(line1, line2) {
    return (
      <>
        <div className="header-font">{line1}</div>
        {line2 ?
          <div className="header-font">{line2}</div>
          : null
        }
      </>
    )
  }

  /** 头部提示 */
  _headerFontCo(type) {
    let line1 = '根据系统中经销商（已开店、建设中）且符合考核配置要求范围的经销商来计算经销商参训指标。';
    let line2 = null;
    if (type == 1) {
      line1 = '只有同时导入考核规则中考核经销商和经销商规模考核规则，则按照考核经销商统计。';
      line2 = '考核经销商中，根据考核配置中考核规则和导入的考核经销商中参训都符合要求的经销商且经销商状态为已开店或建设中，计算经销商参训指标。';
    } else if (type == 2) {
      line1 = '若未导入考核经销商、经销商规模考核规则，则按照正常经销商统计。';
      line2 = '正常经销商中，根据考核配置中考核规则和导入的正常经销商中参训都符合要求的经销商且经销商状态为已开店或建设中，计算经销商参训指标。';
    }
    return this._headerInfo(line1, line2);
  }

  /**岗位组单行表格 */
  _positionRuleRow({name,userTotal, userLoginCount, userLoginRate,userValidCount, userValidRate}) {
    return (
      <tr>
        <td class="table-title" colspan="2">{name}</td>
        <td class="table-title">应参训人数：</td>
        <td class="table-title">{userTotal}</td>
        <td class="table-title">登录人数：</td>
        <td class="table-title">{userLoginCount}</td>
        <td class="table-title">登录率：</td>
        <td class="table-title">{userLoginRate+'%'}</td>
        <td class="table-title">有效参训人数：</td>
        <td class="table-title">{userValidCount}</td>
        <td class="table-title">有效参训率：</td>
        <td class="table-title">{userValidRate+'%'}</td>
      </tr>
    )
  }

  _positionRulesRows(dataItems){
    let rows = [];
    if(dataItems && dataItems instanceof Array){
       dataItems.forEach(e=>{
        rows.push(this._positionRuleRow({...e}))
       })
    }
    return rows;
  }

  _report(type) {
    const { history } = this.props;
    let initialValue=this.initialValue;
    let positionTrainReportList = this.positionTrainReportList;
    let dealerTrainReportList = this.dealerTrainReportList;
    let liveEntityInfo = this.liveEntityInfo;
    const {name,startDate,endDate} = liveEntityInfo;
    const {entityType,syncTime} = initialValue
    let trainReportName = (entityType!=null && entityType===1 ? "直播" : "课程") + "名称";
    if (initialValue && initialValue.bizType!=null && initialValue.bizType===2){
      trainReportName = "组合名称";
    }
    let timeName = (entityType!=null && entityType==1 ? "直播" : "课程") + "时间";
    let updateDate =syncTime ? moment(syncTime).format('YYYY-MM-DD HH:mm') : '';
    let dealerRows = [];
    let positionRows = [];
    if(dealerTrainReportList && dealerTrainReportList instanceof Array && dealerTrainReportList.length>0){
      if (type===1){
        dealerTrainReportList.forEach(value => {
          const {name} = value;
          if (name==='考核经销商' || name==='总经销商'){
            dealerRows.push( this._dealerRow({...value}));
          }
        })
      }else if(type===2){
        dealerTrainReportList.forEach(value => {
          dealerRows.push(this._dealerRow({...value}));
        })
      }else if(type===3){
        dealerTrainReportList.forEach(value => {
          const {name} = value;
          if (name==='总经销商'){
            dealerRows.push(this._dealerRow({...value}))
          }
        })
      }
    }
    if(positionTrainReportList && positionTrainReportList instanceof Array && positionTrainReportList.length>0){
      if(type===1 || type===2){
        positionTrainReportList.forEach(value => {
          const {typeName} = value;
          if (typeName==='部分经销商'){
            positionRows.push( this._positionRuleRow({...value}))
          }
        })
      }else if (type===3){
        positionTrainReportList.forEach(value => {
          const {typeName} = value;
          if (typeName==='全部经销商'){
            positionRows.push(this._positionRuleRow({...value}))
          }
        })
      }
    }
    return (
      <>
        <WizRow>
          <WizCol span={2} >
            <WizIcon type="question-circle" />
            <span className="header-icon-font">参训统计说明</span>
          </WizCol>
          <WizCol span={22} push={1}>{this._headerFontCo(type)}</WizCol>
        </WizRow>
        <br />
        <WizButton.WizGroup>
          {/*<WizHtmlTableToExce*/}
          {/*  className="ant-btn"*/}
          {/*  table={'table-to-xls'+type}*/}
          {/*  filename="参训统计"*/}
          {/*  sheet="参训统计"*/}
          {/*  buttonText="导出参训统计"/>*/}
          <ReactHTMLTableToExcel
            className="ant-btn"
            table={'train_report_excel_'+type}
            filename="参训统计"
            sheet="参训统计"
            buttonText="导出参训统计"/>
          <> 报表更新日期： {updateDate}</>
        </WizButton.WizGroup>

        <div>
          <table id={'train_report_excel_'+type} className="gridtable" >
            <tr>
              <th colspan="16">经销商参训数据统计</th>
            </tr>
            {this._tableRow(trainReportName, name && name)}
            {initialValue && (initialValue.bizType===null || initialValue.bizType===1) ?  this._tableRow(timeName, formatterDate(startDate,endDate)) : null}
            {this._tableRow('考核范围', this.scopeName)}
            {this._tableRow('考核岗位', this.groupPositionName)}
            {
              dealerRows  &&  dealerRows instanceof Array && dealerRows.length>0 ?
              dealerRows :null
            }
            <br />
            <tr>
              <th colspan="16">岗位组统计数据</th>
            </tr>
            { positionRows && positionRows instanceof Array && positionRows.length>0 ?
              positionRows:null
            }
          </table>
        </div>
      </>
    )
  }

  _render() {
    const {positionTrainReportLoading, dealerTrainReportLoading} = this.props;
    let title = '正常';
    let initialValue = this.initialValue;
    const {standard} = initialValue;
    return (
      <WizSpin tip={'加载中'} spinning={dealerTrainReportLoading || positionTrainReportLoading}>
        <WizCard>
          <WizTabs animated={false} onChange={this._onChange.bind(this)}>
            {standard!=null && standard===2 ?
              <WizTabs.TabPane tab="按考核经销商统计" key={1}>
                {this._report(1)}
              </WizTabs.TabPane> :
              <WizTabs.TabPane tab={'按正常经销商统计'} key={2}>
                {this._report(2)}
              </WizTabs.TabPane>
            }
            <WizTabs.TabPane tab={'按全部经销商统计'} key={3}>
              {this._report(3)}
            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {positionTrainReport,dealerTrainReport,positionRule,interactLive} = state;
  const liveEntityInfo = modelUtils.getModelEntity(interactLive, "liveEntityInfo");
  const positionRules = modelUtils.getModelEntity(positionRule, "positionRules");
  const getPositionTrainReportList = modelUtils.getModelEntity(positionTrainReport, "getPositionTrainReportList");
  const getDealerTrainReportList = modelUtils.getModelEntity(dealerTrainReport, "getDealerTrainReportList");
  const load = modelUtils.getLoadingState(state, ['positionTrainReport', 'dealerTrainReport','positionRule','liveEntityInfo']);
  return {
    liveEntityInfo:liveEntityInfo,
    positionRules:positionRules,
    getPositionTrainReportList:getPositionTrainReportList,
    getDealerTrainReportList:getDealerTrainReportList,
    ...load
  };
};

export default connect(mapStateToProps)(TrainReport);
